import { useQuery } from '@tanstack/react-query';

import {
  individualConfigurationsService,
  IndividualConfiguration,
} from '@aslanpay/portal-common-lib';

const useFetchIndividualConfiguration = (id?: string, enabled = true) => {
  return useQuery<IndividualConfiguration, Error>(
    ['fetchIndividualConfiguration', id],
    () => individualConfigurationsService.fetchIndividualConfiguration(id || ''),
    {
      enabled: !!id && enabled,
    }
  );
};

export default useFetchIndividualConfiguration;
